var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _a;
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { apiSlice } from "./api";
var initialState = {
    isAuthenticated: false,
    currentUser: undefined,
    userRights: [],
    token: "",
    refreshToken: "",
    issuedAtTime: Date.now(),
    expirationTime: Date.now(),
    userPreferences: undefined,
};
export var fetchCurrentUserThunk = createAsyncThunk("auth/fetchCurrentUser", function (_, _a) {
    var dispatch = _a.dispatch, getState = _a.getState;
    return __awaiter(void 0, void 0, void 0, function () {
        var data, userData, error_1;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, dispatch(apiSlice.endpoints.getCurrentUser.initiate({}))];
                case 1:
                    data = (_c.sent()).data;
                    userData = (_b = data === null || data === void 0 ? void 0 : data.data) === null || _b === void 0 ? void 0 : _b.record;
                    // Retourne l'objet utilisateur complet, pas juste un ID
                    return [2 /*return*/, userData];
                case 2:
                    error_1 = _c.sent();
                    console.error("[fetchCurrentUserThunk] Erreur", error_1);
                    throw error_1;
                case 3: return [2 /*return*/];
            }
        });
    });
});
var clearTokenThunk = createAsyncThunk("auth/clearToken", function (arg, thunkAPI) {
    var state = thunkAPI.getState();
    var auth = state.auth || {};
    if (auth.isAuthenticated) {
        thunkAPI.dispatch(apiSlice.util.resetApiState());
    }
});
/**
 * Slice pour le stockage de la session utilisateur
 */
export var authSlice = createSlice({
    name: "auth",
    initialState: initialState,
    reducers: {
        setToken: {
            reducer: function (state, _a) {
                var _b = _a.payload, currentUser = _b.currentUser, userRights = _b.userRights, token = _b.token, refreshToken = _b.refreshToken, issuedAtTime = _b.issuedAtTime, expirationTime = _b.expirationTime;
                state.currentUser = currentUser;
                state.userRights = userRights;
                state.token = token;
                state.refreshToken = refreshToken;
                state.issuedAtTime = issuedAtTime;
                state.expirationTime = expirationTime;
                state.isAuthenticated = Boolean(token);
                state.userPreferences = {};
            },
            prepare: function (accessToken) {
                var userRights = (accessToken === null || accessToken === void 0 ? void 0 : accessToken.user_right) || [];
                var token = (accessToken === null || accessToken === void 0 ? void 0 : accessToken.token) || "";
                var refreshToken = (accessToken === null || accessToken === void 0 ? void 0 : accessToken.refreshToken) || "";
                var currentUser = accessToken === null || accessToken === void 0 ? void 0 : accessToken.currentUser;
                var issuedAtTime = accessToken === null || accessToken === void 0 ? void 0 : accessToken.token_iat;
                var expirationTime = accessToken === null || accessToken === void 0 ? void 0 : accessToken.token_exp;
                var userPreferences = {};
                return {
                    payload: {
                        isAuthenticated: false,
                        userRights: userRights,
                        token: token,
                        refreshToken: refreshToken,
                        currentUser: currentUser,
                        issuedAtTime: issuedAtTime,
                        expirationTime: expirationTime,
                        userPreferences: userPreferences,
                    },
                };
            },
        },
        clearTokenUser: function (state) {
            state.isAuthenticated = false;
            state.userRights = [];
            state.token = "";
            state.refreshToken = "";
            state.currentUser = undefined;
            state.issuedAtTime = Date.now();
            state.expirationTime = Date.now();
            state.userPreferences = undefined;
        },
        setCurrentUser: function (state, action) {
            state.currentUser = action.payload;
        },
        setPreferences: function (state, action) {
            state.userPreferences = action.payload;
        },
    },
    extraReducers: function (builder) {
        // Clear token
        builder.addCase(clearTokenThunk.fulfilled, function (state, action) {
            state.isAuthenticated = false;
            state.userRights = [];
            state.token = "";
            state.refreshToken = "";
            state.currentUser = undefined;
            state.issuedAtTime = Date.now();
            state.expirationTime = Date.now();
        });
        builder
            .addCase(fetchCurrentUserThunk.fulfilled, function (state, action) {
            // Mettre à jour l'état avec les données de l'utilisateur complet
            state.currentUser = action.payload;
        })
            .addCase(fetchCurrentUserThunk.rejected, function (state, action) {
            console.error("[fetchCurrentUserThunk] Rejeté", action.error);
        });
    },
});
export var setToken = (_a = authSlice.actions, _a.setToken), setCurrentUser = _a.setCurrentUser, setPreferences = _a.setPreferences, clearTokenUser = _a.clearTokenUser;
export var clearToken = clearTokenThunk;
export default authSlice.reducer;
